import React from "react";
import styled from "styled-components";
import { apiClient } from "../../../../api/client";
import { url } from "../../../../api/index.js";
import { useAppDispatch } from "../../../../store/hooks";
import { signOut } from "../../../../store/slices/authSlice";
import { logout as oauthLogout } from "../../../../utils/oauth";

const SignupMessage = styled.div`
  font-size: 1rem;
  font-weight: 900;
  color: #323232;
  text-align: center;
  margin-top: 2rem;
`;

/**
 * Shown when the backend says the email isn't confirmed. An email code at
 * sign-in is what confirms an address now, so the way out is to sign out and
 * sign back in with one.
 */
export const UnverifiedState: React.FC = () => {
  const dispatch = useAppDispatch();

  // the header's sign-out steps: end the backend session, clear local state,
  // then the IdP logout so the next sign-in asks for a code again
  const handleSignOut = async () => {
    try {
      await apiClient.post(`${url}/api/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.warn("[UnverifiedState] Failed to revoke session on server:", error);
    }
    dispatch(signOut());
    oauthLogout(true);
  };

  return (
    <SignupMessage style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      Your email isn't confirmed yet. Sign out and sign in with an email code to confirm it.
      <button
        type="button"
        onClick={handleSignOut}
        style={{
          marginTop: "15px",
          padding: "8px 16px",
          background: "#444",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
        }}
      >
        Sign out
      </button>
    </SignupMessage>
  );
};

export default UnverifiedState;
